import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-stepByStep';

	$(base, context).each(function(){
		var component = $(this);
		var step = component.find(base + '-step');

		step.on('change', function() {
			var rowStep = $(this).closest('.i-stepByStep-row');
			var nextStep = rowStep.next('.i-stepByStep-row').find('.i-stepByStep-step');
			var allNextSteps = rowStep.nextAll('.i-stepByStep-row').find('.i-stepByStep-step');

			if ($(this).val().length) {
				nextStep.prop('disabled', false);
			} else {
				allNextSteps.val([]).trigger('change');
				allNextSteps.prop('disabled', true);
			}
		});
	});
});